

















































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { cadastroPrestadorService } from "@/service/cadastro/saude/CadastroPrestadorService";
import {
  TipoPrestadorModel,
  tiposPrestadorList,
} from "@/models/cadastros/saude/TipoPrestadorModel";
import { PrestadorResumidoModel } from "@/models/cadastros/saude/PrestadorResumidoModel";
import { PaginationModel } from "@/models/commons/PaginationModel";

@Component({
  components: {
    ValidationObserver,
    GsModalDialog,
  },
})
export default class ListagemPrestadores extends Vue {
  $refs!: {
    filtroObserver: InstanceType<typeof ValidationObserver>;
  };

  cabecalho = [
    { text: "CPF / CNPJ", value: "cpfCnpj", sortable: false, width: "15%" },
    { text: "Nome", value: "nome", sortable: false },
    { text: "E-mail", value: "email", sortable: false, width: "30%" },
    { text: "Tipo", value: "tipoPrestador", sortable: false, width: "15%" },
    { text: "Ações", value: "actions", sortable: false, width: "10%" },
  ];
  options: PaginationModel = {
    page: 1,
    itemsPerPage: 5,
    itemsLength: 0,
  };
  loading = false;

  tiposPrestador = tiposPrestadorList;
  cpfCnpjFiltro = "";
  nomeFiltro = "";
  tipoPrestador: TipoPrestadorModel = {};
  buscaEfetuada = false;
  prestadores: PrestadorResumidoModel[] = [];
  prestadorSelecionado: PrestadorResumidoModel = {
    id: -1,
    cpfCnpj: "",
    nome: "",
    email: "",
    tipoPrestador: {},
  };

  loadingFiltrar = false;

  exibeModalConfirmacao = false;
  loadingExcluir = false;

  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  @Watch("options.page")
  tratarPaginacao() {
    if (this.buscaEfetuada) {
      this.obterDados();
    }
  }

  obterDados() {
    if (this.cpfCnpjFiltro || this.nomeFiltro || this.tipoPrestador.valor) {
      this.buscaEfetuada = true;
      this.loadingFiltrar = true;
      cadastroPrestadorService
        .pesquisarPrestador({
          cpfCnpj: this.cpfCnpjFiltro,
          nome: this.nomeFiltro,
          tipoPrestador: this.tipoPrestador,
          options: this.options,
        })
        .then((res) => {
          this.prestadores = res.conteudo;
          this.options.itemsLength = res.itemsLength;
        })
        .catch((err) => {
          console.log(err.messages);
        })
        .finally(()=> {
          this.loadingFiltrar = false;
        });
    } else {
      this.$refs.filtroObserver.setErrors({
        DOC: "É necessário informar ao menos um filtro",
        Nome: " ",
        "Tipo de prestador": " ",
        Especialidade: " ",
      });
    }

  }

  @Watch("options.itemsPerPage")
  filtrar() {
    this.$refs.filtroObserver.validate().then((valid) => {
      if (valid) {
        if (this.options.page == 1) {
          this.obterDados();
        } else {
          this.options.page = 1;
        }
      }
    });
  }

  solicitarExclusao(prestador: PrestadorResumidoModel) {
    this.prestadorSelecionado = prestador;
    this.exibeModalConfirmacao = true;
  }

  cancelarSolicitacaoExclusao() {
    this.prestadorSelecionado = {
      id: -1,
      cpfCnpj: "",
      nome: "",
      email: "",
      tipoPrestador: {},
    };
    this.exibeModalConfirmacao = false;
  }

  excluir() {
    this.loadingExcluir = true;
    cadastroPrestadorService
      .excluirPrestador(this.prestadorSelecionado.id)
      .then(() => {
        this.exibeModalConfirmacao = false;
        this.openDialog('success', 'Sucesso', `O prestador ${this.prestadorSelecionado.nome} foi excluído com sucesso`);
        this.prestadorSelecionado = {
          id: -1,
          cpfCnpj: "",
          nome: "",
          email: "",
          tipoPrestador: {},
        };
      })
      .catch((err) => {
        this.exibeModalConfirmacao = false;
        this.openDialog('error', 'Erro', err.message);
      })
      .finally(() => {
        this.loadingExcluir = false;
      });
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    if (this.dialogType == 'success') {
      this.filtrar();
    }
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
